type StatusCodeEnum = string;

const toStatusCode = (value: string): StatusCodeEnum => value;

export const Informational = toStatusCode('1xx');
export const Redirection = toStatusCode('3xx');
export const ClientError = toStatusCode('4xx');

export const ServerError = toStatusCode('5xx');
export const Unknown = toStatusCode('unknown');
